import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = {
  key: 0,
  class: "col-md-12"
}
const _hoisted_13 = { class: "alert alert-success mb-4" }
const _hoisted_14 = { class: "mb-0 mt-2" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_21 = { class: "col-md-6" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_27 = { class: "col-md-4" }
const _hoisted_28 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_29 = { class: "col-md-4 d-flex align-items-center" }
const _hoisted_30 = { class: "form-group mb-15 mb-sm-20 mb-md-25 w-100" }
const _hoisted_31 = { class: "form-check" }
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_34 = { class: "col-md-4" }
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_36 = { class: "col-md-4" }
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_40 = { class: "col-md-4" }
const _hoisted_41 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_42 = { class: "col-md-12" }
const _hoisted_43 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_44 = { class: "col-md-4" }
const _hoisted_45 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_46 = { class: "col-md-4" }
const _hoisted_47 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_48 = { class: "col-md-4" }
const _hoisted_49 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_50 = { class: "col-md-4" }
const _hoisted_51 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_52 = { class: "text-muted" }
const _hoisted_53 = { class: "col-md-4" }
const _hoisted_54 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_55 = { class: "col-md-4" }
const _hoisted_56 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_57 = { class: "col-md-12 mb-2" }
const _hoisted_58 = { class: "alert alert-success" }
const _hoisted_59 = { class: "col-md-3" }
const _hoisted_60 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_61 = { class: "col-md-3" }
const _hoisted_62 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_63 = { class: "col-md-3" }
const _hoisted_64 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_65 = { class: "col-md-3" }
const _hoisted_66 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_67 = { class: "col-md-4" }
const _hoisted_68 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_69 = { class: "col-md-4" }
const _hoisted_70 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_71 = { class: "col-md-4" }
const _hoisted_72 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_73 = { class: "col-md-12 mb-2" }
const _hoisted_74 = { class: "alert alert-success" }
const _hoisted_75 = { class: "col-md-4" }
const _hoisted_76 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_77 = { class: "col-md-4" }
const _hoisted_78 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_79 = { class: "col-md-4" }
const _hoisted_80 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_81 = { class: "col-md-4" }
const _hoisted_82 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_83 = { class: "text-muted" }
const _hoisted_84 = { class: "col-md-4" }
const _hoisted_85 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_86 = { class: "col-md-4" }
const _hoisted_87 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_88 = { class: "col-md-4" }
const _hoisted_89 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_90 = { class: "col-md-4" }
const _hoisted_91 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_92 = { class: "col-md-4" }
const _hoisted_93 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_94 = { class: "col-md-4" }
const _hoisted_95 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_96 = { class: "col-md-4" }
const _hoisted_97 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_98 = { class: "col-md-4" }
const _hoisted_99 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_100 = { class: "col-md-6" }
const _hoisted_101 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_102 = { class: "col-md-6" }
const _hoisted_103 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_104 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_105 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_106 = { class: "col-md-4" }
const _hoisted_107 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_108 = { class: "col-md-4" }
const _hoisted_109 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_110 = { class: "col-md-4" }
const _hoisted_111 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_112 = { class: "col-md-4" }
const _hoisted_113 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_114 = { class: "col-md-12" }
const _hoisted_115 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_116 = { class: "d-flex flex-wrap gap-5 align-items-center" }
const _hoisted_117 = { class: "form-check" }
const _hoisted_118 = { class: "form-check" }
const _hoisted_119 = {
  key: 1,
  class: "col-md-4"
}
const _hoisted_120 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_121 = { class: "col-md-12" }
const _hoisted_122 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_123 = { class: "col-md-12 mt-4" }
const _hoisted_124 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "pricingRuleForm",
        onSubmit: _ctx.editPricingRule,
        devtools: { enabled: false }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[126] || (_cache[126] = _createElementVNode("div", { class: "col-md-12 mb-3" }, [
              _createElementVNode("div", { class: "alert alert-primary" }, [
                _createElementVNode("strong", null, "Étape 1 :"),
                _createTextVNode(" Informations de base de la règle ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[35] || (_cache[35] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Code "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "code",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Ex: BESC-BJ-DOSSIER",
                  modelValue: _ctx.formData.code,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.code) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "code",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[36] || (_cache[36] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Nom "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "name",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Ex: Frais de dossier",
                  modelValue: _ctx.formData.name,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.name) = $event))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_ErrorMessage, {
                  name: "name",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _cache[37] || (_cache[37] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Zone Tarifaire "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "tariffZone" }, {
                  default: _withCtx(({ handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.tariffZoneOptions,
                      searchable: true,
                      object: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.formData.tariffZone,
                      "onUpdate:modelValue": (val) => { _ctx.formData.tariffZone = val; handleChange(val); },
                      placeholder: "Sélectionner la zone"
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "tariffZone",
                  class: "text-danger"
                })
              ])
            ]),
            _cache[127] || (_cache[127] = _createElementVNode("div", { class: "col-md-12 mt-3 mb-3" }, [
              _createElementVNode("div", { class: "alert alert-info" }, [
                _createElementVNode("strong", null, "Étape 2 :"),
                _createTextVNode(" Sur quel élément cette règle doit-elle s'appliquer ? ")
              ])
            ], -1)),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[38] || (_cache[38] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Type d'entité "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, { name: "appliesToEntityType" }, {
                  default: _withCtx(({ handleChange }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.entityTypeOptions,
                      searchable: false,
                      object: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.formData.appliesToEntityType,
                      "onUpdate:modelValue": (val) => { 
                    _ctx.formData.appliesToEntityType = val; 
                    handleChange(val);
                    _ctx.onEntityTypeChange(val);
                  },
                      placeholder: "Choisissez le type d'entité..."
                    }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "appliesToEntityType",
                  class: "text-danger"
                })
              ])
            ]),
            (_ctx.selectedEntityType)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.entityTypeHelp.title), 1),
                    _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.entityTypeHelp.description), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.selectedEntityType)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _cache[108] || (_cache[108] = _createElementVNode("div", { class: "col-md-12 mt-3 mb-3" }, [
                    _createElementVNode("div", { class: "alert alert-warning" }, [
                      _createElementVNode("strong", null, "Étape 3 :"),
                      _createTextVNode(" Configuration principale de la règle (obligatoire) ")
                    ])
                  ], -1)),
                  (_ctx.selectedEntityType === 'BESC')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _cache[39] || (_cache[39] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Montant fixe par dossier "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "baseAmount",
                              type: "number",
                              step: "0.01",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "Ex: 50000",
                              modelValue: _ctx.formData.baseAmount,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.baseAmount) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "baseAmount",
                              class: "text-danger"
                            }),
                            _cache[40] || (_cache[40] = _createElementVNode("small", { class: "text-muted" }, "Ce montant sera facturé une seule fois par BESC", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, [
                            _cache[41] || (_cache[41] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Devise "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "amountCurrency" }, {
                              default: _withCtx(({ handleChange }) => [
                                _createVNode(_component_Multiselect, {
                                  options: _ctx.currencyOptions,
                                  searchable: true,
                                  "track-by": "value",
                                  label: "label",
                                  modelValue: _ctx.formData.amountCurrency,
                                  "value-prop": "value",
                                  object: true,
                                  "onUpdate:modelValue": (val) => { _ctx.formData.amountCurrency = val; handleChange(val); },
                                  placeholder: "Sélectionner la devise"
                                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "amountCurrency",
                              class: "text-danger"
                            })
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.selectedEntityType === 'BL')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _cache[42] || (_cache[42] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Montant par BL "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "baseAmount",
                              type: "number",
                              step: "0.01",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "Ex: 16437",
                              modelValue: _ctx.formData.baseAmount,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.baseAmount) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "baseAmount",
                              class: "text-danger"
                            }),
                            _cache[43] || (_cache[43] = _createElementVNode("small", { class: "text-muted" }, "Ce montant sera multiplié par le nombre de BL", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _cache[44] || (_cache[44] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Devise "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "amountCurrency" }, {
                              default: _withCtx(({ handleChange }) => [
                                _createVNode(_component_Multiselect, {
                                  options: _ctx.currencyOptions,
                                  searchable: true,
                                  "track-by": "value",
                                  label: "label",
                                  modelValue: _ctx.formData.amountCurrency,
                                  "value-prop": "value",
                                  object: true,
                                  "onUpdate:modelValue": (val) => { _ctx.formData.amountCurrency = val; handleChange(val); },
                                  placeholder: "Sélectionner la devise"
                                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "amountCurrency",
                              class: "text-danger"
                            })
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.selectedEntityType === 'CONTAINER')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _cache[45] || (_cache[45] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Montant par conteneur "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "perContainerAmount",
                              type: "number",
                              step: "0.01",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "Ex: 3287",
                              modelValue: _ctx.formData.perContainerAmount,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.perContainerAmount) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "perContainerAmount",
                              class: "text-danger"
                            }),
                            _cache[46] || (_cache[46] = _createElementVNode("small", { class: "text-muted" }, "Montant × nombre de conteneurs", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _createElementVNode("div", _hoisted_26, [
                            _cache[47] || (_cache[47] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Devise "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "amountCurrency" }, {
                              default: _withCtx(({ handleChange }) => [
                                _createVNode(_component_Multiselect, {
                                  options: _ctx.currencyOptions,
                                  searchable: true,
                                  "track-by": "value",
                                  label: "label",
                                  modelValue: _ctx.formData.amountCurrency,
                                  "value-prop": "value",
                                  object: true,
                                  "onUpdate:modelValue": (val) => { _ctx.formData.amountCurrency = val; handleChange(val); },
                                  placeholder: "Sélectionner la devise"
                                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "amountCurrency",
                              class: "text-danger"
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _cache[48] || (_cache[48] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Types de conteneur "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "metadata.containerTypes" }, {
                              default: _withCtx(({ handleChange }) => [
                                _createVNode(_component_Multiselect, {
                                  options: _ctx.containerTypeOptions,
                                  searchable: true,
                                  mode: "tags",
                                  "track-by": "value",
                                  label: "label",
                                  modelValue: _ctx.formData.containerTypes,
                                  "value-prop": "value",
                                  object: true,
                                  "onUpdate:modelValue": (val) => { _ctx.formData.containerTypes = val; handleChange(val); },
                                  placeholder: "Sélectionner un ou plusieurs types"
                                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "metadata.containerTypes",
                              class: "text-danger"
                            }),
                            _cache[49] || (_cache[49] = _createElementVNode("small", { class: "text-muted" }, "Obligatoire : choisissez les types concernés", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createVNode(_component_Field, {
                                name: "metadata.requireDistantOrigin",
                                type: "checkbox",
                                class: "form-check-input",
                                id: "requireDistantOrigin",
                                value: true,
                                modelValue: _ctx.formData.requireDistantOrigin,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.requireDistantOrigin) = $event))
                              }, null, 8, ["modelValue"]),
                              _cache[50] || (_cache[50] = _createElementVNode("label", {
                                class: "form-check-label text-black fw-semibold",
                                for: "requireDistantOrigin"
                              }, " Uniquement pour les origines lointaines (Asie, Amérique, Océanie) ", -1))
                            ]),
                            _cache[51] || (_cache[51] = _createElementVNode("small", { class: "text-muted d-block mt-2" }, " Si coché, cette règle ne s'appliquera que si le port de chargement est en Asie, Amérique ou Océanie ", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("div", _hoisted_33, [
                            _cache[52] || (_cache[52] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Date de début "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "effectiveFrom",
                              type: "date",
                              class: "form-control shadow-none fs-md-15 text-black",
                              modelValue: _ctx.formData.effectiveFrom,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.effectiveFrom) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "effectiveFrom",
                              class: "text-danger"
                            }),
                            _cache[53] || (_cache[53] = _createElementVNode("small", { class: "text-muted" }, "Laissez vide pour \"immédiat\"", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _cache[54] || (_cache[54] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Priorité "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "priority" }, {
                              default: _withCtx(({ handleChange }) => [
                                _createVNode(_component_Multiselect, {
                                  options: _ctx.priorityOptions,
                                  searchable: false,
                                  "track-by": "value",
                                  label: "label",
                                  modelValue: _ctx.formData.priority,
                                  "value-prop": "value",
                                  object: true,
                                  "onUpdate:modelValue": (val) => { _ctx.formData.priority = val; handleChange(val); },
                                  placeholder: "Sélectionner la priorité"
                                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "priority",
                              class: "text-danger"
                            }),
                            _cache[55] || (_cache[55] = _createElementVNode("small", { class: "text-muted" }, "Plus le nombre est bas, plus prioritaire", -1))
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.selectedEntityType === 'CARGO_LINE')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _cache[61] || (_cache[61] = _createElementVNode("div", { class: "col-md-12 mb-3" }, [
                          _createElementVNode("div", { class: "alert alert-danger" }, [
                            _createElementVNode("strong", null, "Important :"),
                            _createTextVNode(" La catégorie de produit est OBLIGATOIRE pour ce type de règle afin d'éviter la double facturation ! ")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _cache[56] || (_cache[56] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Catégorie de produit "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "categorieProduit" }, {
                              default: _withCtx(({ handleChange }) => [
                                _createVNode(_component_Multiselect, {
                                  options: _ctx.categorieProduitOptions,
                                  searchable: true,
                                  "track-by": "value",
                                  label: "label",
                                  modelValue: _ctx.formData.categorieProduit,
                                  "value-prop": "value",
                                  object: true,
                                  "onUpdate:modelValue": (val) => { _ctx.formData.categorieProduit = val; handleChange(val); },
                                  placeholder: "Ex: Véhicules"
                                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "categorieProduit",
                              class: "text-danger"
                            }),
                            _cache[57] || (_cache[57] = _createElementVNode("small", { class: "text-muted" }, "Seules les lignes de cette catégorie seront comptées", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _cache[58] || (_cache[58] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Montant par ligne "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "baseAmount",
                              type: "number",
                              step: "0.01",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "Ex: 16387",
                              modelValue: _ctx.formData.baseAmount,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.baseAmount) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "baseAmount",
                              class: "text-danger"
                            }),
                            _cache[59] || (_cache[59] = _createElementVNode("small", { class: "text-muted" }, "Montant × nombre de lignes de la catégorie", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", _hoisted_41, [
                            _cache[60] || (_cache[60] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Devise "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "amountCurrency" }, {
                              default: _withCtx(({ handleChange }) => [
                                _createVNode(_component_Multiselect, {
                                  options: _ctx.currencyOptions,
                                  searchable: true,
                                  "track-by": "value",
                                  label: "label",
                                  modelValue: _ctx.formData.amountCurrency,
                                  "value-prop": "value",
                                  object: true,
                                  "onUpdate:modelValue": (val) => { _ctx.formData.amountCurrency = val; handleChange(val); },
                                  placeholder: "Sélectionner la devise"
                                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "amountCurrency",
                              class: "text-danger"
                            })
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.selectedEntityType === 'GOODS')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                        _cache[91] || (_cache[91] = _createElementVNode("div", { class: "col-md-12 mb-3" }, [
                          _createElementVNode("div", { class: "alert alert-info" }, [
                            _createElementVNode("strong", null, "Marchandises avec conditionnement"),
                            _createElementVNode("p", { class: "mb-0 mt-2" }, " Sélectionnez le type de conditionnement pour appliquer la grille tarifaire correspondante ")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _cache[62] || (_cache[62] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Type de conditionnement "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "packagingType" }, {
                              default: _withCtx(({ handleChange }) => [
                                _createVNode(_component_Multiselect, {
                                  options: _ctx.packagingTypeOptions,
                                  searchable: false,
                                  "track-by": "value",
                                  label: "label",
                                  modelValue: _ctx.formData.packagingType,
                                  "value-prop": "value",
                                  object: true,
                                  "onUpdate:modelValue": (val) => {
                        _ctx.formData.packagingType = val;
                        handleChange(val);
                        _ctx.onPackagingTypeChange(val);
                      },
                                  placeholder: "Choisissez le type de conditionnement..."
                                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "packagingType",
                              class: "text-danger"
                            })
                          ])
                        ]),
                        (_ctx.selectedPackagingType)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (_ctx.selectedPackagingType === 'FCL')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[71] || (_cache[71] = _createElementVNode("div", { class: "col-md-12 mb-2" }, [
                                      _createElementVNode("div", { class: "alert alert-success" }, [
                                        _createElementVNode("strong", null, "Tarification FCL (Conteneurs pleins)")
                                      ])
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_44, [
                                      _createElementVNode("div", _hoisted_45, [
                                        _cache[63] || (_cache[63] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Taille de la tranche "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "trancheSize",
                                          type: "number",
                                          class: "form-control",
                                          placeholder: "5",
                                          modelValue: _ctx.formData.trancheSize,
                                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.formData.trancheSize) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "trancheSize",
                                          class: "text-danger"
                                        }),
                                        _cache[64] || (_cache[64] = _createElementVNode("small", { class: "text-muted" }, "Nombre de conteneurs par tranche (ex: 5)", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_46, [
                                      _createElementVNode("div", _hoisted_47, [
                                        _cache[65] || (_cache[65] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Unité de mesure "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, { name: "unitOfMeasure" }, {
                                          default: _withCtx(({ handleChange }) => [
                                            _createVNode(_component_Multiselect, {
                                              options: _ctx.unitOfMeasureOptions,
                                              searchable: true,
                                              object: true,
                                              "track-by": "value",
                                              label: "label",
                                              modelValue: _ctx.formData.unitOfMeasure,
                                              "onUpdate:modelValue": [
                                                _cache[9] || (_cache[9] = ($event: any) => ((_ctx.formData.unitOfMeasure) = $event)),
                                                handleChange
                                              ]
                                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "unitOfMeasure",
                                          class: "text-danger"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_48, [
                                      _createElementVNode("div", _hoisted_49, [
                                        _cache[66] || (_cache[66] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Max par ECTN", -1)),
                                        _createVNode(_component_Field, {
                                          name: "maxPerEctn",
                                          type: "number",
                                          class: "form-control",
                                          placeholder: "Illimité",
                                          modelValue: _ctx.formData.maxPerEctn,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.formData.maxPerEctn) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "maxPerEctn",
                                          class: "text-danger"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_50, [
                                      _createElementVNode("div", _hoisted_51, [
                                        _cache[67] || (_cache[67] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Tarif Europe/Afrique "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "amountForLocalOrigin",
                                          type: "number",
                                          step: "0.01",
                                          class: "form-control",
                                          placeholder: "25",
                                          modelValue: _ctx.formData.amountForLocalOrigin,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.formData.amountForLocalOrigin) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountForLocalOrigin",
                                          class: "text-danger"
                                        }),
                                        _createElementVNode("small", _hoisted_52, "Par tranche de " + _toDisplayString(_ctx.formData.trancheSize || 5) + " conteneurs", 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_53, [
                                      _createElementVNode("div", _hoisted_54, [
                                        _cache[68] || (_cache[68] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Tarif Autres origines "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "amountForDistantOrigin",
                                          type: "number",
                                          step: "0.01",
                                          class: "form-control",
                                          placeholder: "100",
                                          modelValue: _ctx.formData.amountForDistantOrigin,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.formData.amountForDistantOrigin) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountForDistantOrigin",
                                          class: "text-danger"
                                        }),
                                        _cache[69] || (_cache[69] = _createElementVNode("small", { class: "text-muted" }, "Asie, Amérique, Océanie", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_55, [
                                      _createElementVNode("div", _hoisted_56, [
                                        _cache[70] || (_cache[70] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Devise "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, { name: "amountCurrency" }, {
                                          default: _withCtx(({ handleChange }) => [
                                            _createVNode(_component_Multiselect, {
                                              options: _ctx.currencyOptions,
                                              searchable: true,
                                              "track-by": "value",
                                              label: "label",
                                              modelValue: _ctx.formData.amountCurrency,
                                              "value-prop": "value",
                                              object: true,
                                              "onUpdate:modelValue": (val) => { _ctx.formData.amountCurrency = val; handleChange(val); }
                                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountCurrency",
                                          class: "text-danger"
                                        })
                                      ])
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true),
                              (_ctx.selectedPackagingType === 'ROULANT_LEGER' || _ctx.selectedPackagingType === 'ROULANT_LOURD')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createElementVNode("div", _hoisted_57, [
                                      _createElementVNode("div", _hoisted_58, [
                                        _createElementVNode("strong", null, "Tarification Roulant " + _toDisplayString(_ctx.selectedPackagingType === 'ROULANT_LEGER' ? 'Léger (< 5t)'
                        : 'Lourd (≥ 5t)'), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_59, [
                                      _createElementVNode("div", _hoisted_60, [
                                        _cache[72] || (_cache[72] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Poids minimum (tonnes) "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "minWeight",
                                          type: "number",
                                          step: "0.01",
                                          class: "form-control",
                                          placeholder: _ctx.selectedPackagingType === 'ROULANT_LEGER' ? '0' : '5',
                                          modelValue: _ctx.formData.minWeight,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.formData.minWeight) = $event))
                                        }, null, 8, ["placeholder", "modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "minWeight",
                                          class: "text-danger"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_61, [
                                      _createElementVNode("div", _hoisted_62, [
                                        _cache[73] || (_cache[73] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Poids maximum (tonnes) "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "maxWeight",
                                          type: "number",
                                          step: "0.01",
                                          class: "form-control",
                                          placeholder: _ctx.selectedPackagingType === 'ROULANT_LEGER' ? '4.99' : '999',
                                          modelValue: _ctx.formData.maxWeight,
                                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.formData.maxWeight) = $event))
                                        }, null, 8, ["placeholder", "modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "maxWeight",
                                          class: "text-danger"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_63, [
                                      _createElementVNode("div", _hoisted_64, [
                                        _cache[74] || (_cache[74] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Unité de mesure "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, { name: "unitOfMeasure" }, {
                                          default: _withCtx(({ handleChange }) => [
                                            _createVNode(_component_Multiselect, {
                                              options: _ctx.unitOfMeasureOptions,
                                              searchable: true,
                                              "track-by": "value",
                                              label: "label",
                                              modelValue: _ctx.formData.unitOfMeasure,
                                              "value-prop": "value",
                                              object: true,
                                              "onUpdate:modelValue": (val) => { _ctx.formData.unitOfMeasure = val; handleChange(val); }
                                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "unitOfMeasure",
                                          class: "text-danger"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_65, [
                                      _createElementVNode("div", _hoisted_66, [
                                        _cache[75] || (_cache[75] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Max par ECTN "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "maxPerEctn",
                                          type: "number",
                                          class: "form-control",
                                          placeholder: "1",
                                          modelValue: _ctx.formData.maxPerEctn,
                                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.formData.maxPerEctn) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "maxPerEctn",
                                          class: "text-danger"
                                        }),
                                        _cache[76] || (_cache[76] = _createElementVNode("small", { class: "text-muted" }, "Ex: 1 véhicule maximum par ECTN", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_67, [
                                      _createElementVNode("div", _hoisted_68, [
                                        _cache[77] || (_cache[77] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Tarif Europe/Afrique "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "amountForLocalOrigin",
                                          type: "number",
                                          step: "0.01",
                                          class: "form-control",
                                          placeholder: "25",
                                          modelValue: _ctx.formData.amountForLocalOrigin,
                                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.formData.amountForLocalOrigin) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountForLocalOrigin",
                                          class: "text-danger"
                                        }),
                                        _cache[78] || (_cache[78] = _createElementVNode("small", { class: "text-muted" }, "Par véhicule", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_69, [
                                      _createElementVNode("div", _hoisted_70, [
                                        _cache[79] || (_cache[79] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Tarif Autres origines "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "amountForDistantOrigin",
                                          type: "number",
                                          step: "0.01",
                                          class: "form-control",
                                          placeholder: "25",
                                          modelValue: _ctx.formData.amountForDistantOrigin,
                                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.formData.amountForDistantOrigin) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountForDistantOrigin",
                                          class: "text-danger"
                                        }),
                                        _cache[80] || (_cache[80] = _createElementVNode("small", { class: "text-muted" }, "Asie, Amérique, Océanie", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_71, [
                                      _createElementVNode("div", _hoisted_72, [
                                        _cache[81] || (_cache[81] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Devise "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, { name: "amountCurrency" }, {
                                          default: _withCtx(({ handleChange }) => [
                                            _createVNode(_component_Multiselect, {
                                              options: _ctx.currencyOptions,
                                              searchable: true,
                                              "track-by": "value",
                                              label: "label",
                                              modelValue: _ctx.formData.amountCurrency,
                                              "value-prop": "value",
                                              object: true,
                                              "onUpdate:modelValue": (val) => { _ctx.formData.amountCurrency = val; handleChange(val); }
                                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountCurrency",
                                          class: "text-danger"
                                        })
                                      ])
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true),
                              (['GROUPAGE', 'CONVENTIONNEL', 'VRAC_COMPLET'].includes(_ctx.selectedPackagingType))
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                    _createElementVNode("div", _hoisted_73, [
                                      _createElementVNode("div", _hoisted_74, [
                                        _createElementVNode("strong", null, "Tarification " + _toDisplayString(_ctx.selectedPackagingType === 'GROUPAGE' ? 'Groupage' :
                          _ctx.selectedPackagingType === 'CONVENTIONNEL' ? 'Conventionnel/Vrac' :
                            'Vrac navire complet'), 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_75, [
                                      _createElementVNode("div", _hoisted_76, [
                                        _cache[82] || (_cache[82] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Taille de la tranche (m/t) "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "trancheSize",
                                          type: "number",
                                          class: "form-control",
                                          placeholder: "300",
                                          modelValue: _ctx.formData.trancheSize,
                                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.formData.trancheSize) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "trancheSize",
                                          class: "text-danger"
                                        }),
                                        _cache[83] || (_cache[83] = _createElementVNode("small", { class: "text-muted" }, "Tonnes métriques par tranche (ex: 300)", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_77, [
                                      _createElementVNode("div", _hoisted_78, [
                                        _cache[84] || (_cache[84] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Unité de mesure "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, { name: "unitOfMeasure" }, {
                                          default: _withCtx(({ handleChange }) => [
                                            _createVNode(_component_Multiselect, {
                                              options: _ctx.unitOfMeasureOptions,
                                              searchable: true,
                                              "track-by": "value",
                                              label: "label",
                                              modelValue: _ctx.formData.unitOfMeasure,
                                              "value-prop": "value",
                                              object: true,
                                              "onUpdate:modelValue": (val) => { _ctx.formData.unitOfMeasure = val; handleChange(val); }
                                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "unitOfMeasure",
                                          class: "text-danger"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_79, [
                                      _createElementVNode("div", _hoisted_80, [
                                        _cache[85] || (_cache[85] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Max par ECTN (m/t) "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "maxPerEctn",
                                          type: "number",
                                          class: "form-control",
                                          placeholder: "300",
                                          modelValue: _ctx.formData.maxPerEctn,
                                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.formData.maxPerEctn) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "maxPerEctn",
                                          class: "text-danger"
                                        }),
                                        _cache[86] || (_cache[86] = _createElementVNode("small", { class: "text-muted" }, "Ex: 300 tonnes maximum par ECTN", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_81, [
                                      _createElementVNode("div", _hoisted_82, [
                                        _cache[87] || (_cache[87] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Tarif Europe/Afrique "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "amountForLocalOrigin",
                                          type: "number",
                                          step: "0.01",
                                          class: "form-control",
                                          placeholder: "25",
                                          modelValue: _ctx.formData.amountForLocalOrigin,
                                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.formData.amountForLocalOrigin) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountForLocalOrigin",
                                          class: "text-danger"
                                        }),
                                        _createElementVNode("small", _hoisted_83, "Par tranche de " + _toDisplayString(_ctx.formData.trancheSize || 300) + " m/t", 1)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_84, [
                                      _createElementVNode("div", _hoisted_85, [
                                        _cache[88] || (_cache[88] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Tarif Autres origines "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, {
                                          name: "amountForDistantOrigin",
                                          type: "number",
                                          step: "0.01",
                                          class: "form-control",
                                          placeholder: "100",
                                          modelValue: _ctx.formData.amountForDistantOrigin,
                                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.formData.amountForDistantOrigin) = $event))
                                        }, null, 8, ["modelValue"]),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountForDistantOrigin",
                                          class: "text-danger"
                                        }),
                                        _cache[89] || (_cache[89] = _createElementVNode("small", { class: "text-muted" }, "Asie, Amérique, Océanie", -1))
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_86, [
                                      _createElementVNode("div", _hoisted_87, [
                                        _cache[90] || (_cache[90] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                                          _createTextVNode(" Devise "),
                                          _createElementVNode("span", { class: "text-danger" }, "*")
                                        ], -1)),
                                        _createVNode(_component_Field, { name: "amountCurrency" }, {
                                          default: _withCtx(({ handleChange }) => [
                                            _createVNode(_component_Multiselect, {
                                              options: _ctx.currencyOptions,
                                              searchable: true,
                                              "track-by": "value",
                                              label: "label",
                                              modelValue: _ctx.formData.amountCurrency,
                                              "value-prop": "value",
                                              object: true,
                                              "onUpdate:modelValue": (val) => { _ctx.formData.amountCurrency = val; handleChange(val); }
                                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_ErrorMessage, {
                                          name: "amountCurrency",
                                          class: "text-danger"
                                        })
                                      ])
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.selectedEntityType === 'VALUE_BRACKET')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _cache[103] || (_cache[103] = _createElementVNode("div", { class: "col-md-12 mb-3" }, [
                          _createElementVNode("div", { class: "alert alert-info" }, [
                            _createElementVNode("strong", null, "Tranche de valeur :"),
                            _createTextVNode(" Cette règle ne s'appliquera que si la valeur totale du BESC est dans la tranche définie (toujours en EUROS) ")
                          ])
                        ], -1)),
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("div", _hoisted_89, [
                            _cache[92] || (_cache[92] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Valeur minimum (EUROS) "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "minDeclaredValue",
                              type: "number",
                              step: "0.01",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "Ex: 0",
                              modelValue: _ctx.formData.minDeclaredValue,
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.formData.minDeclaredValue) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "minDeclaredValue",
                              class: "text-danger"
                            })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("div", _hoisted_91, [
                            _cache[93] || (_cache[93] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Valeur maximum (EUROS) "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "maxDeclaredValue",
                              type: "number",
                              step: "0.01",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "Ex: 10000000",
                              modelValue: _ctx.formData.maxDeclaredValue,
                              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.formData.maxDeclaredValue) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "maxDeclaredValue",
                              class: "text-danger"
                            }),
                            _cache[94] || (_cache[94] = _createElementVNode("small", { class: "text-muted" }, "Laissez vide ou mettez un très grand nombre pour \"illimité\"", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_92, [
                          _createElementVNode("div", _hoisted_93, [
                            _cache[95] || (_cache[95] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Taux % "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "percentageRate",
                              type: "number",
                              step: "0.01",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "Ex: 0.05",
                              modelValue: _ctx.formData.percentageRate,
                              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.formData.percentageRate) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "percentageRate",
                              class: "text-danger"
                            }),
                            _cache[96] || (_cache[96] = _createElementVNode("small", { class: "text-muted" }, "% de la valeur déclarée", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_94, [
                          _createElementVNode("div", _hoisted_95, [
                            _cache[97] || (_cache[97] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " OU Montant fixe (EUROS) ", -1)),
                            _createVNode(_component_Field, {
                              name: "baseAmount",
                              type: "number",
                              step: "0.01",
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "Ex: 10000",
                              modelValue: _ctx.formData.baseAmount,
                              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.formData.baseAmount) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "baseAmount",
                              class: "text-danger"
                            }),
                            _cache[98] || (_cache[98] = _createElementVNode("small", { class: "text-muted" }, "Si renseigné, ce montant fixe sera appliqué au lieu du pourcentage", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_96, [
                          _createElementVNode("div", _hoisted_97, [
                            _cache[99] || (_cache[99] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Date de début "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "effectiveFrom",
                              type: "date",
                              class: "form-control shadow-none fs-md-15 text-black",
                              modelValue: _ctx.formData.effectiveFrom,
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.effectiveFrom) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "effectiveFrom",
                              class: "text-danger"
                            }),
                            _cache[100] || (_cache[100] = _createElementVNode("small", { class: "text-muted" }, "Laissez vide pour \"immédiat\"", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_98, [
                          _createElementVNode("div", _hoisted_99, [
                            _cache[101] || (_cache[101] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Priorité "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "priority" }, {
                              default: _withCtx(({ handleChange }) => [
                                _createVNode(_component_Multiselect, {
                                  options: _ctx.priorityOptions,
                                  searchable: false,
                                  "track-by": "value",
                                  label: "label",
                                  modelValue: _ctx.formData.priority,
                                  "value-prop": "value",
                                  object: true,
                                  "onUpdate:modelValue": (val) => { _ctx.formData.priority = val; handleChange(val); },
                                  placeholder: "Sélectionner la priorité"
                                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "priority",
                              class: "text-danger"
                            }),
                            _cache[102] || (_cache[102] = _createElementVNode("small", { class: "text-muted" }, "Plus le nombre est bas, plus prioritaire", -1))
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true),
                  (!['GOODS', 'VALUE_BRACKET', 'CONTAINER'].includes(_ctx.selectedEntityType))
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        _createElementVNode("div", _hoisted_100, [
                          _createElementVNode("div", _hoisted_101, [
                            _cache[104] || (_cache[104] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Date de début "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, {
                              name: "effectiveFrom",
                              type: "date",
                              class: "form-control shadow-none fs-md-15 text-black",
                              modelValue: _ctx.formData.effectiveFrom,
                              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.formData.effectiveFrom) = $event))
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_ErrorMessage, {
                              name: "effectiveFrom",
                              class: "text-danger"
                            }),
                            _cache[105] || (_cache[105] = _createElementVNode("small", { class: "text-muted" }, "Laissez vide pour \"immédiat\"", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_102, [
                          _createElementVNode("div", _hoisted_103, [
                            _cache[106] || (_cache[106] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                              _createTextVNode(" Priorité "),
                              _createElementVNode("span", { class: "text-danger" }, "*")
                            ], -1)),
                            _createVNode(_component_Field, { name: "priority" }, {
                              default: _withCtx(({ handleChange }) => [
                                _createVNode(_component_Multiselect, {
                                  options: _ctx.priorityOptions,
                                  searchable: false,
                                  "track-by": "value",
                                  label: "label",
                                  modelValue: _ctx.formData.priority,
                                  "value-prop": "value",
                                  object: true,
                                  "onUpdate:modelValue": (val) => { _ctx.formData.priority = val; handleChange(val); },
                                  placeholder: "Sélectionner la priorité"
                                }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ErrorMessage, {
                              name: "priority",
                              class: "text-danger"
                            }),
                            _cache[107] || (_cache[107] = _createElementVNode("small", { class: "text-muted" }, "Plus le nombre est bas, plus prioritaire", -1))
                          ])
                        ])
                      ], 64))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true),
            (_ctx.selectedEntityType)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _cache[125] || (_cache[125] = _createElementVNode("div", { class: "col-md-12 mt-4 mb-3" }, [
                    _createElementVNode("div", { class: "alert alert-secondary" }, [
                      _createElementVNode("strong", null, "Étape 4 :"),
                      _createTextVNode(" Options avancées (facultatif) ")
                    ])
                  ], -1)),
                  (!['VALUE_BRACKET', 'BESC', 'BL'].includes(_ctx.selectedEntityType))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                        _createElementVNode("div", _hoisted_105, [
                          _cache[109] || (_cache[109] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Régions du port de chargement ", -1)),
                          _createVNode(_component_Field, { name: "metadata.loadingPortRegion" }, {
                            default: _withCtx(({ handleChange }) => [
                              _createVNode(_component_Multiselect, {
                                options: _ctx.regionOptions,
                                searchable: false,
                                mode: "tags",
                                modelValue: _ctx.formData.loadingPortRegion,
                                "value-prop": "value",
                                object: true,
                                "onUpdate:modelValue": (val) => { _ctx.formData.loadingPortRegion = val; handleChange(val); },
                                placeholder: "Toutes les régions"
                              }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                            ]),
                            _: 1
                          }),
                          _cache[110] || (_cache[110] = _createElementVNode("small", { class: "text-muted" }, "La règle ne s'appliquera que si le port de chargement est dans ces régions", -1))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_106, [
                    _createElementVNode("div", _hoisted_107, [
                      _cache[111] || (_cache[111] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Date de fin", -1)),
                      _createVNode(_component_Field, {
                        name: "effectiveTo",
                        type: "date",
                        class: "form-control shadow-none fs-md-15 text-black",
                        modelValue: _ctx.formData.effectiveTo,
                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.formData.effectiveTo) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_ErrorMessage, {
                        name: "effectiveTo",
                        class: "text-danger"
                      }),
                      _cache[112] || (_cache[112] = _createElementVNode("small", { class: "text-muted" }, "Laissez vide pour \"sans limite\"", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _createElementVNode("div", _hoisted_109, [
                      _cache[113] || (_cache[113] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Régime douanier (optionnel)", -1)),
                      _createVNode(_component_Field, { name: "regimedouanier" }, {
                        default: _withCtx(({ handleChange }) => [
                          _createVNode(_component_Multiselect, {
                            options: _ctx.regimeDouanierOptions,
                            searchable: true,
                            "track-by": "value",
                            label: "label",
                            modelValue: _ctx.formData.regimedouanier,
                            "value-prop": "value",
                            object: true,
                            "onUpdate:modelValue": (val) => { _ctx.formData.regimedouanier = val; handleChange(val); },
                            placeholder: "Sélectionner un régime"
                          }, null, 8, ["options", "modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_110, [
                    _createElementVNode("div", _hoisted_111, [
                      _cache[114] || (_cache[114] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Montant min facturé", -1)),
                      _createVNode(_component_Field, {
                        name: "minFeeAmount",
                        type: "number",
                        step: "0.01",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Ex: 1000",
                        modelValue: _ctx.formData.minFeeAmount,
                        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.formData.minFeeAmount) = $event))
                      }, null, 8, ["modelValue"]),
                      _cache[115] || (_cache[115] = _createElementVNode("small", { class: "text-muted" }, "Plafond minimum", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_112, [
                    _createElementVNode("div", _hoisted_113, [
                      _cache[116] || (_cache[116] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Montant max facturé", -1)),
                      _createVNode(_component_Field, {
                        name: "maxFeeAmount",
                        type: "number",
                        step: "0.01",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Ex: 100000",
                        modelValue: _ctx.formData.maxFeeAmount,
                        "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.formData.maxFeeAmount) = $event))
                      }, null, 8, ["modelValue"]),
                      _cache[117] || (_cache[117] = _createElementVNode("small", { class: "text-muted" }, "Plafond maximum", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("div", _hoisted_115, [
                      _createElementVNode("div", _hoisted_116, [
                        _createElementVNode("div", _hoisted_117, [
                          _createVNode(_component_Field, {
                            name: "isExemptionRule",
                            type: "checkbox",
                            class: "form-check-input",
                            id: "isExemptionRule",
                            value: true,
                            modelValue: _ctx.formData.isExemptionRule,
                            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.formData.isExemptionRule) = $event))
                          }, null, 8, ["modelValue"]),
                          _cache[118] || (_cache[118] = _createElementVNode("label", {
                            class: "form-check-label text-black fw-semibold",
                            for: "isExemptionRule"
                          }, " Règle d'exemption (réduction) ", -1))
                        ]),
                        _createElementVNode("div", _hoisted_118, [
                          _createVNode(_component_Field, {
                            name: "isActive",
                            type: "checkbox",
                            class: "form-check-input",
                            id: "isActive",
                            value: true,
                            modelValue: _ctx.formData.isActive,
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.formData.isActive) = $event))
                          }, null, 8, ["modelValue"]),
                          _cache[119] || (_cache[119] = _createElementVNode("label", {
                            class: "form-check-label text-black fw-semibold",
                            for: "isActive"
                          }, " Activer cette règle immédiatement ", -1))
                        ])
                      ])
                    ])
                  ]),
                  (_ctx.formData.isExemptionRule)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_119, [
                        _createElementVNode("div", _hoisted_120, [
                          _cache[120] || (_cache[120] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Taux d'exemption (%) ", -1)),
                          _createVNode(_component_Field, {
                            name: "exemptionRate",
                            type: "number",
                            step: "0.01",
                            class: "form-control shadow-none fs-md-15 text-black",
                            placeholder: "Ex: 10",
                            modelValue: _ctx.formData.exemptionRate,
                            "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.formData.exemptionRate) = $event))
                          }, null, 8, ["modelValue"]),
                          _createVNode(_component_ErrorMessage, {
                            name: "exemptionRate",
                            class: "text-danger"
                          }),
                          _cache[121] || (_cache[121] = _createElementVNode("small", { class: "text-muted" }, "% de réduction", -1))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_121, [
                    _createElementVNode("div", _hoisted_122, [
                      _cache[122] || (_cache[122] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Description", -1)),
                      _createVNode(_component_Field, {
                        name: "description",
                        as: "textarea",
                        rows: "3",
                        class: "form-control shadow-none fs-md-15 text-black",
                        placeholder: "Décrivez cette règle en détail...",
                        modelValue: _ctx.formData.description,
                        "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.formData.description) = $event))
                      }, null, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_123, [
                    _createElementVNode("div", _hoisted_124, [
                      _cache[124] || (_cache[124] = _createElementVNode("button", {
                        type: "submit",
                        class: "default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                      }, " Modifier la règle ", -1)),
                      _createVNode(_component_router_link, {
                        to: "/listeBescPricingRule",
                        class: "btn btn-danger transition border-0 lh-1 fw-medium pt-10 pb-10 ps-25 pe-25"
                      }, {
                        default: _withCtx(() => [...(_cache[123] || (_cache[123] = [
                          _createTextVNode(" Annuler ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}